/* es6-symbol/validate-symbol */ function _(require, module, exports) {
    var isSymbol = require(386) /* ./is-symbol */;
    module.exports = function (value) {
        if (!isSymbol(value))
            throw new TypeError(value + " is not a symbol");
        return value;
    };
}
